import {
  getZoomScale,
  ZOOM_SCALE_MAX,
} from '~/client/src/shared/map/mapZoomRule'
import { MARKER_SPEC } from '~/client/src/shared/map/markerGeometry'

import {
  COUNTED_PIN_POPUP_CLEARANCE_PX,
  PIN_POPUP_CLEARANCE_PX,
  POPUP_CLEARANCE_GAP_PX,
} from '../SitemapHelpers/utils/GLWorkflowPinImageGenerator'
import { ANCHORED_LIFT_PX } from './GLWorkflowPinLayer'

// How far a popup's tip sits from the pin it grew from. Three things move it: a counted pin has to
// clear its own count bubble, a pin that rides a marker sits lifted, and both scale with the pin.
// Shared pins pass isAnchored false — they never ride a marker, and giving them the local pin's
// numbers pushed the tip a full-size distance from a zoom-scaled pin.
export const pinPopupOffset = (
  count: number,
  isAnchored: boolean,
  pinScale: number,
): number =>
  Math.round(
    ((count > 1 ? COUNTED_PIN_POPUP_CLEARANCE_PX : PIN_POPUP_CLEARANCE_PX) +
      (isAnchored ? ANCHORED_LIFT_PX : 0)) *
      pinScale,
  )

// A location marker is centred on its coordinate, so its popup clears the top half. Half a pin's
// gap: the circle is small and round, and the full gap read as detached.
export const markerPopupOffset = (markerScale: number): number =>
  Math.round(
    (MARKER_SPEC.outerSize / 2 + POPUP_CLEARANCE_GAP_PX / 2) * markerScale,
  )

// The scale a popup's clearance rides, or the tip floats away from the pin at low zoom.
//
// readZoom is a thunk, not a number, and that is the point: `viewport` is replaced on every camera
// frame, so an observer that reads it unconditionally re-renders through a whole pan. Passing the
// read lazily makes "only while a popup is open" a property of this function rather than a comment
// each caller has to remember.
export const popupPinScale = (
  isPopupOpen: boolean,
  isZoomScalingEnabled: boolean,
  readZoom: () => number,
): number =>
  isPopupOpen && isZoomScalingEnabled
    ? getZoomScale(readZoom() ?? ZOOM_SCALE_MAX)
    : 1
